// Route: /media/upload — full-page batch upload replacing MediaUploadModal (Phase 15, L9).
// beforeLoad enforces org-member auth via parent _admin layout (requireOrg already runs).
import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/lib/auth/require-role";
import { UploadPage } from "@/features/media/upload-page/upload-page";

export const Route = createFileRoute("/_admin/media/upload")({
  beforeLoad: () => requireRole("member"),
  component: UploadPage,
});
